<template>
  <el-dialog :visible.sync="dialogTableVisible" top="2%">
    <span slot="title" class="dialog-title">发票填写</span>
    <el-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      label-width="120px"
      label-position="left"
      style="width: 95%; margin: 0 auto"
    >
      <el-form-item label="开票类型">
        <el-radio-group v-model="formData.invoiceCreateType">
          <el-radio label="1">增值税普通发票</el-radio>
          <el-radio label="2">增值税专用发票</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="抬头类型">
        <el-radio-group v-model="formData.invoiceMajorType">
          <el-radio label="1">企业</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发票材质">
        <el-radio-group v-model="formData.invoiceType">
          <el-radio label="1">数电发票</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开票金额">
        <el-input v-model="formData.price" disabled></el-input>
      </el-form-item>
      <el-form-item label="企业名称" prop="name">
        <el-input
          v-model="formData.name"
          placeholder="请注意填写完整企业全称"
        ></el-input>
      </el-form-item>
      <el-form-item label="纳税人识别号" prop="creditNo">
        <el-input
          v-model="formData.creditNo"
          placeholder="请输入纳税人识别号"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="企业注册地址"
        prop="registryAddress"
        :required="formData.invoiceCreateType !== '1'"
      >
        <el-input
          v-model="formData.registryAddress"
          :placeholder="
            formData.invoiceCreateType == '1'
              ? '非必填项，为方便报销，请尽量填写此项'
              : '请输入企业注册地址'
          "
        ></el-input>
      </el-form-item>
      <el-form-item
        label="企业注册电话"
        prop="registryPhoneNo"
        :required="formData.invoiceCreateType !== '1'"
      >
        <el-input
          v-model="formData.registryPhoneNo"
          :placeholder="
            formData.invoiceCreateType == '1'
              ? '非必填项，为方便报销，请尽量填写此项'
              : '请输入企业注册电话'
          "
        ></el-input>
      </el-form-item>
      <el-form-item
        label="开户银行"
        prop="registryBank"
        :required="formData.invoiceCreateType !== '1'"
      >
        <el-input
          v-model="formData.registryBank"
          :placeholder="
            formData.invoiceCreateType == '1'
              ? '非必填项，为方便报销，请尽量填写此项'
              : '请输入开户银行'
          "
        ></el-input>
      </el-form-item>
      <el-form-item
        label="银行账号"
        prop="registryBankAccount"
        :required="formData.invoiceCreateType !== '1'"
      >
        <el-input
          v-model="formData.registryBankAccount"
          :placeholder="
            formData.invoiceCreateType == '1'
              ? '非必填项，为方便报销，请尽量填写此项'
              : '请输入银行账号'
          "
        ></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="formData.description"
          placeholder="非必填项"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="invoice-tip">
      提示：请按照电子商务法及发票管理办法等相关规定填写发票信息，若因填写无效信息或非法信息等造成包括但不限于无法成功开具发票等后果或法律责任，由您自行承担。
    </div>
    <div class="invoice-button">
      <el-button plain @click="dialogTableVisible = false">取消</el-button>
      <el-button type="primary" @click="submit" :loading="loading"
        >提交</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ApplyInvoice",
  props: {},
  data() {
    return {
      loading: false,
      dialogTableVisible: false,
      formData: {
        orderId: "",
        invoiceCreateType: "1",
        invoiceMajorType: "1",
        invoiceType: "1",
        price: "",
        name: "",
        creditNo: "",
        registryAddress: "",
        registryPhoneNo: "",
        registryBank: "",
        registryBankAccount: "",
        description: "",
      },
      rules: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        creditNo: [
          { required: true, message: "请输入纳税人识别号", trigger: "blur" },
        ],
        registryAddress: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.invoiceCreateType !== "1" && !value) {
                callback(new Error("请输入企业注册地址"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        registryPhoneNo: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.invoiceCreateType !== "1" && !value) {
                callback(new Error("请输入企业注册电话"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        registryBank: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.invoiceCreateType !== "1" && !value) {
                callback(new Error("请输入开户银行"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        registryBankAccount: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.invoiceCreateType !== "1" && !value) {
                callback(new Error("请输入银行账号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    "formData.invoiceCreateType"() {
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate([
            "name",
            "creditNo",
            "registryAddress",
            "registryPhoneNo",
            "registryBank",
            "registryBankAccount",
          ]);
        }
      });
    },
  },
  methods: {
    async submit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        await this.$api.order.CreateOrderInvoice(this.formData);
        this.loading = false;
        this.$notify({
          title: "提交成功!",
          type: "success",
          message: "可在“订单管理”内查看。",
          dangerouslyUseHTMLString: true,
          position: "bottom-right",
          duration: 4000,
          customClass: "notify-success-title",
        });
        this.dialogTableVisible = false;
        this.$emit("submit");
      });
    },
    async show(row) {
      this.formData.orderId = row.id;
      this.formData.price = row.actualPriceStr;
      this.formData.invoiceCreateType = "1";
      this.formData.name = "";
      this.formData.creditNo = "";
      this.formData.registryAddress = "";
      this.formData.registryPhoneNo = "";
      this.formData.registryBank = "";
      this.formData.registryBankAccount = "";
      this.formData.description = "";
      this.dialogTableVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
::v-deep .el-form-item.is-required .el-form-item__label::before {
  color: #f56c6c !important;
  font-size: 14px;
  margin-left: -10px;
}
</style>
<style lang="scss" scoped>
@import "./applyInvoice.scss";
</style>
